import React from "react";
import {
  DeploymentRequestDetailPageContent,
  DeploymentRequestDetailPageStateProvider,
} from ".";
import { DeploymentRequestInfomationInputDialogStateProvider } from "../dialog/deployment-request-infomation-input-dialog";

export const DeploymentRequestDetailPage = () => {
  return (
    <>
      <DeploymentRequestInfomationInputDialogStateProvider>
        <DeploymentRequestDetailPageStateProvider>
          <DeploymentRequestDetailPageContent></DeploymentRequestDetailPageContent>
        </DeploymentRequestDetailPageStateProvider>
      </DeploymentRequestInfomationInputDialogStateProvider>
    </>
  );
};
